import axios from 'axios'
import queryString from 'querystring'
import setting from '../services/appsettings'
import browser from './browser-check'
import { Loading } from 'element-ui'

axios.defaults.baseURL = setting.apiUrl
axios.defaults.withCredentials = true

// http request 拦截器
var loadinginstace
axios.interceptors.request.use(
  config => {
    if (browser.isIE() && config.method === 'get') {
      if (config.url.indexOf('?') === -1) {
        config.url = config.url + '?random=' + Math.random()
      } else {
        config.url = config.url + '&random=' + Math.random()
      }
    }
    // element ui Loading方法
    loadinginstace = Loading.service({ fullscreen: true, background: '#00000000', text: '加载中' })

    return config
  },
  error => {
    setTimeout(() => {
      loadinginstace.close()
    }, 1000)
    return Promise.reject(error)
  }
)

// http response 拦截器
axios.interceptors.response.use(
  response => {
    loadinginstace.close()
    return response
  },
  error => {
    if (error.response.status === 401) {
      window.location.href = `/login`
    }
    setTimeout(() => {
      loadinginstace.close()
    }, 1000)
    return Promise.reject(error)
  }
)

function query (url, data, config) {
  if (data) {
    url = `${url}?${queryString.stringify(data)}`
  }
  return axios.get(url, config)
}

export default {...axios, query}
